/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {};

const getters = {};

const actions = {
  async getDataTracking({ commit }, data) {
    try {
      const response = await axios.get(
        `${url}/data-tracking-sheets/${data.clientId}/${data.staffId}`
      );
      return response.data;
    } catch (error) {
      return response.error;
    }
  },

  async createDataTracking({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets`,
        data.data,
        {
          params: data.params,
        }
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },

  async getJDTAttendanceReportPDF({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets/jdt-attendance-report`,
        data
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },
  async getJDTProgressReportPDF({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets/jdt-progress-report`,
        data
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },
  async getRSSInterminateSupportPDF({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets/rss-interminate-support`,
        data
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },
  async getRSSLog24PDF({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets/rss-log-24`,
        data
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },
  async getSLAProgressReportPDF({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets/sla-progress-report`,
        data
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },
  async getSupplmentalResidentialSupportPDF({ commit }, data) {
    try {
      const response = await axios.post(
        `${url}/data-tracking-sheets/supplemental-residential-support`,
        data
      );
      return response;
    } catch (error) {
      return response.error;
    }
  },
};

const mutations = {
  SET_LOADING(state, data) {
    state.loading = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
